/* PMP Optik C (28.09.2026): Kaufbereich auf Produktseiten.
   1. teeinblue zeigt Farben und Größen mit den Kürzeln seines Basisprodukts (athletic-heather, military-green …)
      und in zufälliger Reihenfolge. Angezeigt wird stattdessen der Shopify-Optionswert derselben Variante,
      also Deutsch bzw. die Übersetzung der gewählten Sprache. Größen werden von XS bis 5XL bzw. aufsteigend sortiert,
      vorgewählt ist M statt der teuren ersten teeinblue-Größe.
   2. Gestalter-Kasten: bei Näpfen „Gestalte deinen Napf“, ohne sichtbares Feld (reine Spruchtassen) ganz ausgeblendet.
   3. Handy: die klebende Kaufleiste (teeinblue und Theme) verdeckt nie den Preis.
   5. (03.10.2026) Handy-Kaufleiste erst nach dem echten Kaufknopf (ersetzt die Regel "schon im ersten Bildschirm");
      festes Motiv ohne Vorschau-Knopf, Kastentitel "Wähle deine Variante".
   4. (01.10.2026) Natur-Taschen: teeinblue wählt seine erste Farbe (Schwarz) vor, obwohl Shopify „Natur“ als Standard
      führt. Nur auf Seiten mit -natur im Pfad wird nach dem Laden die Shopify-Standardfarbe angeklickt, solange niemand
      selbst gewählt hat und kein Variantenlink offen ist. */
(() => {
  'use strict';
  if (window.__pmpOptikC) return;
  window.__pmpOptikC = true;
  const cfg = window.PMP_OPTIK_C || {};
  const de = (cfg.locale || 'de').slice(0, 2) === 'de';

  /* Rückfall nur für Deutsch, falls eine Variante keinem Shopify-Wert zuzuordnen ist. */
  const WB = {
    color: {
      'athletic-heather': 'Grau meliert', 'black': 'Schwarz', 'Black': 'Schwarz', 'dark-grey-heather': 'Dunkelgrau meliert',
      'dark-heather': 'Anthrazit meliert', 'forest': 'Waldgrün', 'forest-green': 'Flaschengrün', 'light-blue': 'Hellblau',
      'Light Blue': 'Hellblau', 'light-pink': 'Hellrosa', 'maroon': 'Bordeaux', 'military-green': 'Olivgrün', 'navy': 'Navy',
      'natural': 'Natur', 'pink': 'Rosa', 'Hot Pink': 'Pink', 'red': 'Rot', 'sand': 'Sand', 'soft-cream': 'Creme',
      'sport-grey': 'Hellgrau meliert', 'sports-grey': 'Hellgrau meliert', 'white': 'Weiß', 'White': 'Weiß',
      'baby-blue': 'Babyblau', 'heather-gray': 'Grau meliert', 'Heather': 'Grau meliert', 'Glossy': 'Glänzend', 'Matte': 'Matt',
      'Wood': 'Holz', 'heat-transfer-black': 'Schwarz', 'ceramic-white': 'Weiß', 'stainless-steel-white': 'Weiß', 'Black/White': 'Schwarz und Weiß', 'Dotted': 'Gepunktet'
    },
    size: { 'Standard sized tote bag': 'Standardgröße', '6M': '6 Monate', '12M': '12 Monate', '18M': '18 Monate', '5/6': '5 bis 6 Jahre' }
  };

  const GR = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, '2XL': 6, '3XL': 7, '4XL': 8, '5XL': 9 };
  const rang = (v) => {
    const k = String(v || '').trim().toUpperCase();
    if (k in GR) return GR[k];
    const m = String(v || '').replace(',', '.').match(/^\s*(\d+(?:\.\d+)?)/);
    return m ? 100 + parseFloat(m[1]) : null;
  };

  /* ---------- 1. Variantennamen ---------- */
  const C = window.teeinblueCampaign;
  let karte = null;
  const baueKarte = (c) => {
    const sv = (C && C.variantsById) || {};
    const iv = {};
    (c.instance_variants || []).forEach((x) => { if (x.platform_linked_id) iv[x.variant_id] = sv[x.platform_linked_id]; });
    const k = {};
    (c.campaign_products || []).forEach((cp) => {
      const pid = String(cp.product_id || (cp.product && cp.product.id));
      const e = (k[pid] = {});
      ['color', 'size'].forEach((a) => {
        const werte = {};
        (cp.campaign_variants || []).forEach((v) => {
          const s = v[a] || (v.variant && v.variant[a]);
          if (s) (werte[s] = werte[s] || []).push(iv[v.variant_id]);
        });
        const slugs = Object.keys(werte);
        if (slugs.length < 2) return;
        /* Die Shopify-Option finden, deren Wert je Kürzel eindeutig ist. */
        for (let i = 0; i < 3; i++) {
          const n = {};
          let ok = true;
          for (const s of slugs) {
            const w = new Set(werte[s].filter(Boolean).map((x) => x.options && x.options[i]));
            if (w.size !== 1) { ok = false; break; }
            n[s] = [...w][0];
            if (!n[s]) { ok = false; break; }
          }
          if (ok && new Set(Object.values(n)).size === slugs.length) { e[a] = n; break; }
        }
      });
    });
    return k;
  };
  let selbstGewaehlt = false;
  let farbeGewaehlt = false;
  let zielFarbe = null;
  let kampagne = null;
  const nurNatur = /-natur(\/|$)/.test(location.pathname);
  document.addEventListener('change', (e) => {
    if (!e.isTrusted || window.__pmpAutoKlick || !e.target || !e.target.closest) return;
    if (e.target.closest('.tee-option--size')) selbstGewaehlt = true;
    if (e.target.closest('.tee-option--color')) farbeGewaehlt = true;
  }, true);
  const name = (a, pid, wert) => (karte && karte[pid] && karte[pid][a] && karte[pid][a][wert]) || (de && WB[a][wert]) || null;

  /* Natur-Taschen: teeinblue setzt seine erste Farbe teils auch nach unserem Klick erneut. Deshalb alle 0,4 s prüfen
     (höchstens 24 Mal), bis die Shopify-Standardfarbe steht oder jemand selbst gewählt hat. */
  /* Standardfarbe laut Shopify: die Variante, die Shopify als gewählt führt, zurück auf das teeinblue-Farbkürzel.
     Shopify setzt den Wert erst nach dem Laden der Kampagnendaten, deshalb erst im Prüfschritt ermitteln. */
  const ermittleZiel = () => {
    if (zielFarbe || !kampagne) return;
    const sid = String((window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) || '');
    if (!sid) return;
    const ivx = (kampagne.instance_variants || []).find((x) => String(x.platform_linked_id) === sid);
    if (ivx) (kampagne.campaign_products || []).forEach((cp) => {
      const cv = (cp.campaign_variants || []).find((v) => v.variant_id === ivx.variant_id);
      const s = cv && (cv.color || (cv.variant && cv.variant.color));
      if (s) zielFarbe = s;
    });
  };
  const farbeVorwahl = () => {
    if (!nurNatur || /[?&]variant=/.test(window.PMP_START_SUCHE != null ? window.PMP_START_SUCHE : location.search)) return;
    let n = 0, fest = 0;
    const t = setInterval(() => {
      n++;
      if (farbeGewaehlt || n > 24) { clearInterval(t); return; }
      ermittleZiel();
      if (!zielFarbe) return;
      const inp = document.querySelector('.tee-option--color input[value="' + zielFarbe + '"]');
      if (!inp) return;
      if (inp.checked) { if (++fest >= 4) clearInterval(t); return; }
      fest = 0;
      const r = inp.closest('.tee-radio');
      const l = r && r.querySelector('label');
      if (l && !inp.disabled) { window.__pmpAutoKlick = true; try { l.click(); } finally { window.__pmpAutoKlick = false; } }
    }, 400);
  };

  const beschriften = () => {
    document.querySelectorAll('.tee-variants .tee-option--color, .tee-variants .tee-option--size').forEach((opt) => {
      const a = opt.classList.contains('tee-option--color') ? 'color' : 'size';
      const radios = [...opt.querySelectorAll('.tee-radio')];
      radios.forEach((r) => {
        const inp = r.querySelector('input');
        const lab = r.querySelector('label');
        if (!inp || !lab) return;
        const pid = (String(inp.name).match(/-(\d+)$/) || [])[1];
        const n = name(a, pid, inp.value);
        if (n && lab.getAttribute('data-pmp-name') !== n) { lab.setAttribute('data-pmp-name', n); lab.title = n; }
      });
      if (a === 'size' && radios.length > 1) {
        const rs = radios.map((r) => rang(r.querySelector('input') && r.querySelector('input').value));
        if (rs.every((x) => x !== null)) {
          opt.classList.add('pmp-sortiert');
          radios.forEach((r, i) => { const o = String(Math.round(rs[i] * 10)); if (r.style.order !== o) r.style.order = o; });
          /* teeinblue wählt die erste Größe seiner Liste vor (oft 2XL, teurer). Solange niemand selbst gewählt hat und
             kein Variantenlink (Google Shopping) offen ist: M, sonst die kleinste Größe. */
          if (!selbstGewaehlt && !/[?&]variant=/.test(window.PMP_START_SUCHE != null ? window.PMP_START_SUCHE : location.search)) {
            const m = radios.find((r) => (r.querySelector('input') || {}).value === 'M');
            const ziel = m || radios[rs.indexOf(Math.min(...rs))];
            if (ziel && !ziel.classList.contains('active') && !ziel.querySelector('input:disabled')) {
              const l = ziel.querySelector('label');
              if (l) { window.__pmpAutoKlick = true; try { l.click(); } finally { window.__pmpAutoKlick = false; } }
            }
          }
        }
      }
      opt.querySelectorAll('select option').forEach((o) => {
        const sel = o.closest('select');
        const pid = sel && (String(sel.name).match(/-(\d+)$/) || [])[1];
        const n = name(a, pid, o.value);
        if (n && o.textContent !== n) o.textContent = n;
      });
    });
  };

  /* ---------- 2. Gestalter-Kasten ---------- */
  const kasten = () => {
    document.querySelectorAll('.tee-customize-main-form').forEach((f) => {
      const felder = [...f.querySelectorAll('.tee-field')];
      const leer = felder.length > 0 && felder.every((x) => x.classList.contains('sr-only') || x.style.display === 'none');
      f.classList.toggle('pmp-leer', leer);
      /* (03.10.2026) Festes Motiv (Liquid: keine Foto- oder Namenspersonalisierung) und im Gestalter kein sichtbares Feld
         außer der reinen Druckvariante (tee-field--template, z. B. hell/dunkel bei der Edition): kein Vorschau-Knopf,
         keine Kachel Live-Vorschau, Kastentitel "Wähle deine Variante". Jedes andere sichtbare Feld (Text, Foto, Spruch-
         oder Motivauswahl) zählt als Personalisierung; im Zweifel bleibt die Vorschau. */
      const eingabe = felder.some((x) => !x.classList.contains('sr-only') && x.style.display !== 'none' && x.offsetParent !== null && !x.classList.contains('tee-field--template'));
      const fest = !!cfg.fest && felder.length > 0 && !eingabe;
      document.documentElement.classList.toggle('pmp-fest', fest);
      const titel = fest && cfg.titelFest ? cfg.titelFest : cfg.titel;
      const t = f.querySelector('.tee-form-header__title');
      if (t && titel && t.textContent !== titel) t.textContent = titel;
    });
  };

  /* ---------- 3. Kaufleiste und Preis ---------- */
  const handy = window.matchMedia('(max-width: 989px)');
  const leiste = () => {
    const vh = window.innerHeight;
    const preis = document.querySelector('.tee-product-price');
    const akt = document.querySelector('.tee-form-actions');
    if (preis && akt) {
      const p = preis.getBoundingClientRect();
      /* klebt unten mit bottom:0, Oberkante also bei vh minus eigener Höhe */
      const deckt = handy.matches && p.height > 0 && p.top < vh && p.bottom > vh - akt.offsetHeight;
      akt.classList.toggle('pmp-ruhig', deckt);
    }
    const sticky = document.querySelector('[data-sticky-atc]');
    const tpreis = document.querySelector('.product__info [data-price-current]') || document.querySelector('.product__info .price');
    if (sticky && tpreis) {
      const p = tpreis.getBoundingClientRect();
      const h = sticky.offsetHeight || 80;
      sticky.classList.toggle('pmp-ruhig', p.height > 0 && p.top < vh && p.bottom > vh - h);
    }
  };

  /* ---------- 5. (03.10.2026) Handy-Kaufleiste erst, wenn der echte Kaufknopf nach oben aus dem Bild ist.
     Vorher klebte sie schon beim Laden unten und verdeckte Versandzeile und erste Option.
     teeinblue-Seiten: der teeinblue-Kaufbereich steht jetzt normal im Formular (CSS pmp-tee-leiste); die Theme-Leiste
     (Bild, Titel, Preis, In den Warenkorb) erscheint erst danach, ihr Knopf löst den teeinblue-Kaufknopf aus, nie das
     versteckte Theme-Formular. Theme-Seiten: theme.js setzt is-visible, die Klasse pmp-nach-knopf gibt die Leiste frei. ---------- */
  let kBeob = null, kZiel = null;
  const teeLeiste = () => {
    const sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky || !('IntersectionObserver' in window)) return;
    const akt = document.querySelector('.tee-form-actions');
    const themeKnopf = document.querySelector('[data-add-to-cart]');
    const ziel = akt || themeKnopf;
    if (!ziel) return;
    if (akt) document.documentElement.classList.add('pmp-tee-leiste');
    if (akt && !sticky.dataset.pmpTee) {
      sticky.dataset.pmpTee = '1';
      sticky.addEventListener('click', (ev) => {
        if (!ev.target.closest('button')) return;
        const k = document.querySelector('.tee-form-actions .tee-btn--atc');
        if (!k) return;
        ev.stopPropagation();
        ev.preventDefault();
        k.click();
      }, true);
    }
    if (kZiel === ziel) return;
    if (kBeob) kBeob.disconnect();
    kZiel = ziel;
    kBeob = new IntersectionObserver((en) => {
      const e = en[en.length - 1];
      const oben = !e.isIntersecting && e.boundingClientRect.bottom <= (e.rootBounds ? e.rootBounds.top : 0);
      sticky.classList.toggle('pmp-nach-knopf', oben);
      if (!akt) return;
      const an = handy.matches && oben && akt.offsetParent !== null;
      if (an) {
        const p = document.querySelector('.tee-product-price');
        const z = sticky.querySelector('[data-sticky-price]');
        const txt = p && p.textContent.replace(/\s+/g, ' ').trim();
        if (z && txt && z.textContent !== txt) z.textContent = txt;
      }
      sticky.classList.toggle('is-visible', an);
    }, { threshold: 0 });
    kBeob.observe(ziel);
  };

  let geplant = false;
  const lauf = () => {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(() => { geplant = false; beschriften(); kasten(); leiste(); teeLeiste(); });
  };

  const start = () => {
    const ziel = document.querySelector('[data-product-form]') || document.querySelector('.product__info') || document.body;
    new MutationObserver(lauf).observe(ziel, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', lauf, { passive: true });
    window.addEventListener('resize', lauf);
    lauf();
    if (C && C.productId) {
      const shop = (window.Shopify && window.Shopify.shop) || '9d9nrd-kr.myshopify.com';
      fetch('https://api.teeinblue.com/api/merchant/campaigns/' + C.productId + '.json?shop=' + shop + '&v=' + (C.version || ''))
        .then((r) => (r.ok ? r.json() : null))
        .then((c) => {
          if (c) {
            karte = baueKarte(c);
            kampagne = c;
            farbeVorwahl();
            lauf();
          }
        })
        .catch(() => {});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
